export default __webpack_public_path__ + "static/kurier-805abafae6f4b5729c4ba285e4ddaa98.svg";